import createIcon from '../../createIcon';

/**
 * @component @name LogoDev
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk03LjY4IDE0Ljk4SDZWOUg3LjcxQzguOTkgOSA5LjQyIDEwLjAzIDkuNDIgMTAuNzFWMTMuMjdDOS40MiAxMy45NSA5IDE0Ljk4IDcuNjggMTQuOThaTTEyLjM4IDExLjQ2VjEyLjUzSDExLjJWMTMuOTJIMTMuMTNWMTQuOTlIMTAuODhDMTAuNDggMTUgMTAuMTQgMTQuNjggMTAuMTMgMTQuMjhWOS43NUMxMC4xMiA5LjM1IDEwLjQ0IDkuMDEgMTAuODQgOUgxMy4xMlYxMC4wN0gxMS4yVjExLjQ2SDEyLjM4Wk0xNi44OCAxNC4yM0MxNi40IDE1LjM0IDE1LjU1IDE1LjEyIDE1LjE3IDE0LjIzTDEzLjc3IDlIMTQuOTVMMTYuMDIgMTMuMTFMMTcuMDkgOUgxOC4yN0wxNi44OCAxNC4yM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik03Ljc3IDEwLjEySDcuMTRWMTMuODlINy43N0M3LjkxIDEzLjg5IDguMDUgMTMuODQgOC4xOSAxMy43M0M4LjMzIDEzLjYzIDguNCAxMy40NyA4LjQgMTMuMjZWMTAuNzRDOC40IDEwLjUzIDguMzMgMTAuMzcgOC4xOSAxMC4yN0M4LjA1IDEwLjE3IDcuOTEgMTAuMTIgNy43NyAxMC4xMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LogoDev = createIcon('LogoDev', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM7.68 14.98H6V9H7.71C8.99 9 9.42 10.03 9.42 10.71V13.27C9.42 13.95 9 14.98 7.68 14.98ZM12.38 11.46V12.53H11.2V13.92H13.13V14.99H10.88C10.48 15 10.14 14.68 10.13 14.28V9.75C10.12 9.35 10.44 9.01 10.84 9H13.12V10.07H11.2V11.46H12.38ZM16.88 14.23C16.4 15.34 15.55 15.12 15.17 14.23L13.77 9H14.95L16.02 13.11L17.09 9H18.27L16.88 14.23Z',
      key: '8vopbt',
    },
  ],
  [
    'path',
    {
      d: 'M7.77 10.12H7.14V13.89H7.77C7.91 13.89 8.05 13.84 8.19 13.73C8.33 13.63 8.4 13.47 8.4 13.26V10.74C8.4 10.53 8.33 10.37 8.19 10.27C8.05 10.17 7.91 10.12 7.77 10.12Z',
      key: '7hponn',
    },
  ],
]);

export default LogoDev;
